import getCdnUrl from '../../../helpers/get-cdn-url';

const BancoDeChileLogoBlue = getCdnUrl('/logos/banco-de-chile-blue.avif');

export default BancoDeChileLogoBlue;
